import Select from 'react-select';
import { getRandomUid } from 'utilities/uuid.service';
import { useEffect, useState } from 'react';

function TeachersMultiSelect({ value, handleChange, options = [], isMulti = false }) {
  const [defaultTeachers, setDefaultTeachers] = useState([]);
  const _id = getRandomUid();

  useEffect(() => {
    if (value) {
      if (typeof value === 'string') {
        const found = options.find((t) => t._id === value);
        setDefaultTeachers(found ? [found] : []);
      } else if (Array.isArray(value)) {
        setDefaultTeachers(value);
      } else {
        setDefaultTeachers([]);
      }
    } else {
      setDefaultTeachers([]);
    }
  }, [value, options]);

  const formattedOptions = options.map((t) => ({
    value: t._id,
    label: t.name,
  }));

  const handleSelectChange = (selected) => {
    if (isMulti) {
      handleChange(selected);
    } else {
      handleChange(selected);
    }
  };

  return (
    <>
      <label htmlFor={_id}>Assigned Teacher *</label>
      <Select
        styles={{
          control: (baseStyles, state) => ({
            ...baseStyles,
            borderColor: '#e9baf0',
            'box-shadow': '0 0.8rem 1.2rem rgba(20, 102, 204, 0.14)',
          }),
          singleValue: (styles) => ({
            ...styles,
          }),
          option: (styles, { isSelected }) => ({
            ...styles,
            backgroundColor: isSelected ? '#e9baf0' : 'white',
            color: isSelected ? 'black' : 'black',
          }),
        }}
        inputId={_id}
        isMulti={isMulti}
        options={formattedOptions}
        onChange={handleSelectChange}
        value={
          isMulti
            ? defaultTeachers.map((t) => ({ value: t._id, label: t.name }))
            : defaultTeachers.length > 0
            ? { value: defaultTeachers[0]._id, label: defaultTeachers[0].name }
            : null
        }
        isClearable
        isSearchable
        placeholder="Select a teacher..."
        isDisabled={options.length === 0}
      />
    </>
  );
}

TeachersMultiSelect.defaultProps = {
  value: null,
  isMulti: false,
  options: [],
  handleChange: () => {},
};

export default TeachersMultiSelect;
